function DtToolBar(props) {
  return (
    <div
      className={`${props.className} flex flex-row items-center justify-between pb-3 border-b sm:flex sm:items-center sm:justify-between bg-white`}
    >
      <h3 className="text-lg font-semibold leading-6 text-gray-900">
        {props.name}
        {!props.hideCount && (
          <span className="inline-flex items-center rounded-full bg-blue-50 ml-2 px-2 py-1 text-sm font-medium text-blue-700 ring-1 ring-inset ring-blue-700/10">
            {props.totalCount}
          </span>
        )}
      </h3>
      <div className="mt-3 sm:ml-4 sm:mt-0">
        <div className="flex space-x-2">
          {props.children.map((child) => (
            <>
              <div className="relative flex-grow focus-within:z-10 rounded-md mx-5">
                {child}
              </div>
            </>
          ))}
        </div>
      </div>
    </div>
  );
}

export default DtToolBar;
